// ---------------- Login Start -------------------------------------------------------------------------------------------
const ForgotPassword = () => import ('./components/Login/ForgotPassword.vue');
const ChangePassword = () => import ('./components/Login/ChangePassword.vue');
const epsLogin = () => import ('./components/Login/Login.vue');
const epsHome = () => import ('./components/Dashboard/Home.vue');
const Resetpassword = () => import ('./components/Login/Resetpassword.vue');
// ---------------- Login End ---------------------------------------------------------------------------------------------
// ---------------- signup start ------------------------------------------------------------------------------------------
const signup = () => import ('./components/Login/Signup.vue');
// ---------------- signup End --------------------------------------------------------------------------------------------
// ---------------- profile start -----------------------------------------------------------------------------------------
const profile = () => import ('./components/profile/FillProfile.vue');
// ---------------- profile End -------------------------------------------------------------------------------------------
// ---------------- SPC Admission start -----------------------------------------------------------------------------------
const spcprofile = () => import ('./components/SPCAdmission/dashboard/SPCFillProfile.vue');
const FillmeritformHomepage = () => import ('./components/SPCAdmission/dashboard/FillmeritformHomepage.vue');


const admissionschedule = () => import ('./components/SPCAdmission/dashboard/AdmissionSchedule.vue');
const admissionprocess = () => import ('./components/SPCAdmission/dashboard/AdmissionProcess.vue');
const SPCHome = () => import ('./components/Dashboard/SPChome.vue');
const Dashboard = () => import ('./components/SPCAdmission/dashboard/Dashboard.vue');
const spclogin = () => import ('./components/SPCAdmission/login/Login.vue');
const spcsignup = () => import ('./components/SPCAdmission/login/Signup.vue');
const spcForgotPassword = () =>import ('./components/SPCAdmission/login/ForgotPassword.vue');
const spcChangePassword = () => import ('./components/SPCAdmission/login/ChangePassword.vue');
const MeritListStatus = () => import ('./components/SPCAdmission/dashboard/MeritListStatus.vue');
const PaymentReceipt = () => import ('./components/SPCAdmission/dashboard/PaymentReceipt.vue');
const PaymentFailed = () => import ('./components/SPCAdmission/dashboard/PaymentFailure.vue');
const ApplicationForm = () => import ('./components/SPCAdmission/ApplicationForm/ApplicationForm.vue');
const ApplicationFormFees = () => import ('./components/SPCAdmission/ApplicationForm/AdmissionPayFees.vue');
const AdmissionFormstatus = () => import ('./components/SPCAdmission/dashboard/AdmissionFormstatus.vue');
const AdmissionPayFeesResponse = () => import ('./components/SPCAdmission/ApplicationForm/AdmissionPayFeesResponse.vue');
const RegularReceipt = () =>import ('./components/SPCAdmission/ApplicationForm/RegularReceipt.vue');

const AdmissionFormCreditDetails = () => import ('./components/SPCAdmission/dashboard/AdmissionFormCreditDetails.vue');

const FetchAdmissionApplicationFormdata = () =>import ('./components/SPCAdmission/ApplicationForm/FetchAdmissionApplicationFormdata.vue');

const PaymentFeesResponse = () =>import ('./components/SPCAdmission/dashboard/PaymentFeesResponse.vue');
//Grievance----------
const AddGrievance = () =>import ('./components/SPCAdmission/Grievance/AddGrievance.vue');

const AdmissionSubjectPreferenceForm = () =>import ('./components/SPCAdmission/ApplicationForm/AdmissionSubjectPreferenceForm.vue');


// ---------------- SPC Admission End -------------------------------------------------------------------------------------------

export const routes = [{
        path: '/',
        component: spclogin
    },
    {
        path: '/forgot-password/change-password',
        name: 'changepassword',
        component: ChangePassword
    },
    {
        path: '/spcforgot-password/spcchange-password',
        name: 'spcchangepassword',
        component: spcChangePassword
    },
    {
        path: '/forgot-password',
        component: ForgotPassword,
    },
    {
        path: '/spcforgot-password',
        component: spcForgotPassword,
    },
    {
        path: '/update-password',
        name: 'update-password',
        component: Resetpassword
    },
    {
        path: '/signup',
        name: 'signup',
        component: signup
    },
    {
        path: '/login',
        component: epsHome,
        children: []
    },
    {
        path: '/spclogin',
        name: 'spclogin',
        component: spclogin,
        
    },
    {
        path: '/dashboard',
        component: SPCHome,
        children: [
            {
                path: 'student_profile',
                name: 'Dashboard',
                component: Dashboard,
                meta: {
                    requiresAuth: true,
                    userType: "Learner"
                },
            },
            {
                path: 'home',
                name: 'profile',
                component: profile,
                meta: {
                    requiresAuth: true,
                    userType: "Learner"
                },
            },
            {
                path: 'spcprofile',
                name: 'spcprofile',
                component: spcprofile,
                meta: {
                    requiresAuth: true,
                    userType: "Learner"
                },
            },
            {
                path: 'fillmeritformhomepage',
                name: 'fillmeritformhomepage',
                component: FillmeritformHomepage,
                meta: {
                    requiresAuth: true,
                    userType: "Learner"
                },
            },
            
            {
                path: 'merit-list-status',
                name: 'merit-list-status',
                component: MeritListStatus,
                meta: {
                    requiresAuth: true,
                    userType: "Learner"
                },
            },
            {
                path: 'admissionschedule',
                name: 'admissionschedule',
                component: admissionschedule,
                meta: {
                    requiresAuth: true,
                    userType: "Learner"
                },
            },
            {
                path: 'applicationfrom',
                name: 'applicationfrom',
                component: ApplicationForm,
                meta: {
                    requiresAuth: true,
                    userType: "Learner"
                },
            },
            
            {
                path: 'fetchApplicationformdata',
                name: 'fetchApplicationformdata',
                component: FetchAdmissionApplicationFormdata,
                meta: {
                    requiresAuth: true,
                    userType: "Learner"
                },
            },

            {
                path: 'admissionprocess',
                name: 'admissionprocess',
                component: admissionprocess,
                meta: {
                    requiresAuth: true,
                    userType: "Learner"
                },
            },
            {
                path: 'payment-receipt',
                name: 'PaymentReceipt',
                component: PaymentReceipt,
                meta: {
                    requiresAuth: true,
                    userType: "Learner"
                },
            },
            {
                path: 'transaction-failure',
                name: 'transaction-failure',
                component: PaymentFailed,
                meta: {
                    requiresAuth: true,
                    userType: "Learner"
                },
            },
            {
                path: 'admission-pay-fees',
                name: 'admission-pay-fees',
                component: ApplicationFormFees,
                meta: {
                    requiresAuth: true,
                    userType: "Learner"
                },
            },
            {
                path: 'admission-form-status',
                name: 'admission-form-status',
                component: AdmissionFormstatus,
                meta: {
                    requiresAuth: true,
                    userType: "Learner"
                },
            },
            {
                path: 'admission-pay-fees-responce',
                name: 'AdmissionPayFeesResponce',
                component: AdmissionPayFeesResponse,
                meta: {
                    requiresAuth: true,
                    userType: "Learner"
                },
            },
            {
                path: 'admission-fee-receipt',
                name: 'RegularReceipt',
                component: RegularReceipt,
                meta: {
                    requiresAuth: true,
                    userType: "Learner"
                },
            },
            {
                path: 'application-fee-receipt',
                name: 'PaymentFeesResponse',
                component: PaymentFeesResponse,
                meta: {
                    requiresAuth: true,
                    userType: "Learner"
                },
            },
            {
                path: 'admissionform-creditdetails',
                name: 'AdmissionFormCreditDetails',
                component: AdmissionFormCreditDetails,
                meta: {
                    requiresAuth: true,
                    userType: "Learner"
                },
            },
            
            //Grievance----------
            {
                path: 'add-grievance',
                name: 'add-grievance',
                component: AddGrievance
            },
          {
                path: 'AdmissionSubjectPreferenceForm',
                name: 'AdmissionSubjectPreferenceForm',
                component: AdmissionSubjectPreferenceForm
            },
              /*{
                path: 'fy-ba',
                name: 'fy-ba',
                component: FYBA
            },
            {
                path: 'fy-bcom',
                name: 'fy-bcom',
                component: FYBCOM
            },*/
        ]
    },
    {
        path: '/spcsignup',
        name: 'spcsignup',
        component: spcsignup
    },



];
export default routes;